import React from 'react';
import PropTypes from 'prop-types';
import Slider from 'react-slick';
import './index.css';

const Carousel = ({ children, options }) => (
  <Slider {...options} className="carousel">
    {children}
  </Slider>
);

Carousel.propTypes = {
  children: PropTypes.node,
  options: PropTypes.object,
};

Carousel.defaultProps = {
  options: {
    dots: true,
    arrows: false,
    infinite: false,
    slidesToShow: 1,
    slidesToScroll: 1,
  },
};
export default Carousel;



// WEBPACK FOOTER //
// ./src/common/components/Carousel/index.js